module.exports = __webpack_public_path__ + "img/successful.c0473a0b.png";